import { OauthService } from './services/oauth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private oauth: OauthService
    ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
     const requestPath  = next.url;
     if (!this.checkTokenIsValid()){
      this.router.navigateByUrl('login');
      return false;
    } else {
      return true;
    }
  }

  private checkTokenIsValid() {
    const token =  this.oauth.getToken();
    if (token) {
      return true;
    }
    return false;
  }
}
